import api from '@/utils/httpClient';
import serviceUrls from '@oncolens/oncolens-ui/lib/api/service-urls';
import { ApiListResponse } from '@oncolens/oncolens-ui/lib/dto/api/ApiResponse';
import { OrganizationExpertDto } from '@oncolens/oncolens-ui/lib/dto/organization/OrganizationExpert';
import { useQuery } from 'react-query';

export const getOrganizationExperts = (organizationId: string) => {
  return api
    .get(`${serviceUrls.ADMIN()}/api/organizations/${organizationId}/experts`)
    .then((response) => (response.data as ApiListResponse<OrganizationExpertDto>).data);
};

export const useGetOrganizationExperts = (organizationId: string) => {
  return useQuery(['request'], () => getOrganizationExperts(organizationId), {
    enabled: !!organizationId
  });
};
